import React from 'react';

import { ArticleMode } from '../../../common/spdCore/validation/schemas';
import { GetExamDto } from '../../../common/spdCore/autogenerated/spdApiClient';

import { ExamSpecialistEndedLink } from './ExamSpecialistEndedLink';

export const ExamSpecialistRoleEndedLink = (props: {
  examId: string | undefined;
  examNumber: number | undefined;
  exam?: GetExamDto;
  mode?: ArticleMode | null;
  onChange?: () => void;
}) => {
  return (
    <>
      {props.mode === ArticleMode.Ophthalmologist && (
        <ExamSpecialistEndedLink
          examId={props.examId}
          examNumber={props.examNumber}
          specialistEnded={props.exam?.ophthalmologistEnded}
          textVersion1="okulisty"
          textVersion2="okulistyczne"
          specialist="ophthalmologist"
          onChange={props.onChange}
        />
      )}
      {props.mode === ArticleMode.Laryngologist && (
        <ExamSpecialistEndedLink
          examId={props.examId}
          examNumber={props.examNumber}
          specialistEnded={props.exam?.laryngologistEnded}
          textVersion1="laryngologa"
          textVersion2="laryngologiczne"
          specialist="laryngologist"
          onChange={props.onChange}
        />
      )}
      {props.mode === ArticleMode.Neurologist && (
        <ExamSpecialistEndedLink
          examId={props.examId}
          examNumber={props.examNumber}
          specialistEnded={props.exam?.neurologistEnded}
          textVersion1="neurologa"
          textVersion2="neurologiczne"
          specialist="neurologist"
          onChange={props.onChange}
        />
      )}
      {props.mode === ArticleMode.Psychiatrist && (
        <ExamSpecialistEndedLink
          examId={props.examId}
          examNumber={props.examNumber}
          specialistEnded={props.exam?.psychiatristEnded}
          textVersion1="psychiatry"
          textVersion2="psychiatryczne"
          specialist="psychiatrist"
          onChange={props.onChange}
        />
      )}
    </>
  );
};
